export function accordion() {
    //active state on accordionnavigation
  var headerAccordionWrapper = document.querySelectorAll('.wp-block-ub-content-toggle-accordion-title-wrap');

  if (!headerAccordionWrapper.length) {
    // alert('no accordion found');
    return;
  }

  headerAccordionWrapper.forEach(function (headerWrapper) {

    headerWrapper.addEventListener('click', function () {
      // turn off all active classes
      headerAccordionWrapper.forEach(function (e) {
        e.classList.remove('active');
      });
      headerWrapper.classList.toggle('active');
    }, true)
  });

  // copy the header to the toggle menu
  var headerAccordion = document.querySelectorAll('.wp-block-ub-content-toggle-accordion-content-wrap h2');
  var toggleContent = document.querySelectorAll('.wp-block-ub-content-toggle-accordion-toggle-wrap.right');
  let i = 0;

  headerAccordion.forEach(function (header) {

      toggleContent[i].innerHTML = header.innerHTML;
      // wrap the content in a div
      toggleContent[i].innerHTML = '<h3 class="toggle-content">' + toggleContent[i].innerHTML + '</h3>';
      header.innerHTML = '';
      i++;
    }
  );
}

export function tabs() {

  // get all titles of the tabs wp-block-ub-tabbed-content-tab-title
  var tabTitles = document.querySelectorAll('.wp-block-ub-tabbed-content-tab-title');
  if (!tabTitles.length) {
    return;
  }
  //for each title
  tabTitles.forEach(function (tabTitle) {
    // add an event listener
    tabTitle.addEventListener('click', function () {
      // turn off all active classes
      document.getElementById('stappen').scrollIntoView();
    })
  });


  // create hover effect on the tabs
  var tabContent = document.querySelectorAll('.wp-block-ub-tabbed-content-tab-title-wrap');
  // console.log(tabContent);
  if (!tabContent.length) {
    return;
  }
  //for each title
  tabContent.forEach(function (tab) {
   
    // add an event listener for hover
    // Wouter special
    tab.addEventListener('mouseover', function () {
      // turn off all active classes
      // console.log(tab);
      tabContent.forEach(function (e) {
        e.classList.remove('active');
      });
      tab.classList.toggle('active');
      // get panel number from id after "tab-" and show the panel
      var panelNumber = tab.id.split('tab-')[1];
      // console.log(panelNumber);
      // get all panels
      var panels = document.querySelectorAll('.wp-block-ub-tabbed-content-tab-content-wrap');
      // console.log(panels);
      // turn off all panels
      panels.forEach(function (panel) {
        panel.classList.remove('active');
        panel.classList.add('ub-hide');

      });
      // show the panel
      document.getElementById('ub-tabbed-content--panel-' + panelNumber).classList.toggle('active');
      document.getElementById('ub-tabbed-content--panel-' + panelNumber).classList.toggle('ub-hide');
    })
  });
}